import { render, staticRenderFns } from "./CommentsPane.vue?vue&type=template&id=12372ef1"
import script from "./CommentsPane.vue?vue&type=script&lang=js"
export * from "./CommentsPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports